import Menu from './menu';
import Google from '../../helpers/google';

export default class MenuMobile extends Menu {
    constructor(...args) {
		super(...args);

		this._isOpen = false;
		this._submenuIsOpen = false;
		this._submenuIndexOpen = null;

		this._scrollPosition = null;

		this._initDom();
		this._event();
	}

	_initDom() {
		this.dom.burger = document.body.querySelector('.js-burger');
		this.dom.logo = document.body.querySelector('.logo-head-mobile');
        this.dom.targetHover = [].slice.call( this.dom.component.querySelectorAll('.js-target-hover.has-children') );

        this._heightItemDefault = [];
        this._heightItemSmall = [];
        for( let i = 0; i < this.dom.targetHover.length; i++ ) {
            let element = this.dom.targetHover[i];
            this._heightItemDefault.push( element.offsetHeight );

            let linkParent = element.querySelector('.js-item-parent');
            this._heightItemSmall.push( linkParent.offsetHeight );

            element.style.height = linkParent.offsetHeight + 'px';
        }
	}

	_event() {
		this.dom.burger.addEventListener('click', ()=>{
			if (this._isOpen == false) {
				this._open();
			} else {
				this._close();
			}
		});

        for( let i = 0; i < this.dom.targetHover.length; i++ ) {

            let element = this.dom.targetHover[i];

            element.addEventListener( 'click', ( event ) => {
                let element = event.currentTarget;
                let index = this.dom.targetHover.indexOf( element );

                if( this._submenuIsOpen ) {
                    this.dom.targetHover[ this._submenuIndexOpen ].style.height = this._heightItemSmall[ this._submenuIndexOpen ] + 'px';
                    this._submenuIsOpen = false;
                }

                if( this._submenuIndexOpen != index ) {
                    element.style.height = this._heightItemDefault[ index ] + 'px';
                    this._submenuIndexOpen = index;
                    this._submenuIsOpen = true;
                } else {
                    this._submenuIndexOpen = null;
                }

            } )
        }
	}

	_open() {
		Google.pushCustomTracker('Menu', 'Open');
		this._isOpen = true;
		this.dom.component.classList.add('show');
		this.dom.burger.classList.add('active');

        document.body.classList.add('no-scroll');

		this.dom.logo.classList.add('hide');
	}

	_close() {
		this._isOpen = false;
		this.dom.component.classList.remove('show');
		this.dom.burger.classList.remove('active');

        document.body.classList.remove('no-scroll');

		this.dom.logo.classList.remove('hide');
	}


    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/menu/menu.mobile.js